// extracted by css-extract-rspack-plugin
export default {"root":"mFVzc","root_fill":"OtKT3","rootFill":"OtKT3","slot":"Flv6K","fallback":"u22we","fallback_image":"JO_Es","fallbackImage":"JO_Es"};